export default __webpack_public_path__ + "static/media/icon2.d8e0e2d9.svg";